const FALSE_SENTINEL = 'false';
const ISO_DATE = /^(\d{4})-(\d{2})-(\d{2})$/;

function text(value: unknown): string | null {
  if (value == null || value === false) return null;
  const raw = String(value).trim();
  if (!raw || raw.toLowerCase() === FALSE_SENTINEL) return null;
  return raw;
}

function calendarDay(value: unknown): string | null {
  const raw = text(value);
  if (!raw) return null;
  const match = ISO_DATE.exec(raw.slice(0, 10));
  if (!match) return null;
  const month = Number(match[2]);
  const day = Number(match[3]);
  if (month < 1 || month > 12 || day < 1 || day > 31) return null;
  return `${match[1]}-${match[2]}-${match[3]}`;
}

function isDisabled(enabled: unknown): boolean {
  return enabled != null && text(enabled) == null;
}

function hasNotStarted(startDate: unknown, today: string): boolean {
  const startsOn = calendarDay(startDate);
  return startsOn != null && startsOn > today;
}

function hasEnded(endDate: unknown, today: string): boolean {
  const endsOn = calendarDay(endDate);
  return endsOn != null && endsOn < today;
}

/** Keeps an offer unless enabled is present and empty, start_date is after today, or end_date is before today. */
export function isActive(
  offer: { readonly enabled?: unknown; readonly start_date?: unknown; readonly end_date?: unknown },
  today: string,
): boolean {
  return !isDisabled(offer.enabled) && !hasNotStarted(offer.start_date, today) && !hasEnded(offer.end_date, today);
}
